import React from 'react';
import { List } from 'react-native-paper';
import styled, { css } from '@emotion/native';
import { green, accent } from '@/shared/styles/colors';
import { SideMenuIconType } from '@/shared/types/navigation';

interface SideMenuItemProps {
  icon: SideMenuIconType;
  title: string;
  isActive: boolean;
  onPress: () => void;
  isLargeDesktop: boolean;
}

const SideMenuItem = ({
  icon,
  title,
  isActive,
  onPress,
  isLargeDesktop,
}: SideMenuItemProps) => {
  return (
    <ListItem
      title={title}
      left={() => (
        <StyledImage
          source={isActive && icon.selected ? icon.selected : icon.default}
          resizeMode="contain"
          isLargeDesktop={isLargeDesktop}
        />
      )}
      onPress={onPress}
      active={isActive}
      isLargeDesktop={isLargeDesktop}
      titleStyle={{
        ...titleStyle,
        fontWeight: isActive ? 'bold' : 'normal',
        fontSize: isLargeDesktop ? 16 : 14,
      }}
    />
  );
};

export default SideMenuItem;

const StyledImage = styled.Image<{ isLargeDesktop: boolean }>(
  ({ isLargeDesktop }) => ({
    width: isLargeDesktop ? 24 : 20,
    height: isLargeDesktop ? 24 : 20,
    marginLeft: 8,
  }),
);

const ListItem = styled(List.Item)<{
  active?: boolean;
  isLargeDesktop: boolean;
}>(({ active, isLargeDesktop }) => ({
  backgroundColor: active ? accent : 'transparent',
  borderRadius: isLargeDesktop ? 65 : 57.8,
  paddingLeft: 10,
  paddingVertical: 8,
}));

const titleStyle = css({
  color: green,
  fontFamily: 'Helvetica',
  fontSize: 16,
  letterSpacing: -0.16,
});
